<fieldset [disabled]="!editable">
	<div class="d-flex">
		<label class="btn btn-success">
			<input class="d-none" type="file" (change)="uploadFile($event)" />
			<i class="fa-solid fa-file-circle-plus"></i> Wgraj zdjęcie z pliku
		</label>
	</div>
	<mat-table
		#dataTable
		*ngIf="data.multimedia"
		[dataSource]="data.multimedia"
		cdkDropList
		(cdkDropListDropped)="dropTable($event)"
	>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef> Nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.multimedia.name }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="order">
			<mat-header-cell *matHeaderCellDef> Kolejność </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.order }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="link">
			<mat-header-cell *matHeaderCellDef> Link </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div *ngIf="element.multimedia.url">
					<a [href]="element.multimedia.url" target="_blank">Link do zdjęcia</a>
				</div>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="url">
			<mat-header-cell *matHeaderCellDef> Zdjęcie </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<img [src]="element.multimedia.url" width="60%" />
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">
				<button mat-raised-button color="warn" [disabled]="!editable" (click)="deleteImage(i)">
					<i class="fa-solid fa-trash-can"></i> Usuń zdjęcie
				</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<div *ngIf="!data.multimedia?.length" class="alert mt-4 alert-warning text-center">Brak multimediów</div>
</fieldset>
